<script lang="ts">
export default {
  name: 'AccountRenewalView',
};
</script>

<script setup lang="ts">
import { accountService } from '@/services/api';
import { groupedProgramRates, ProgramRateGroup } from '@/types/ProgramRates';
import Renewals from '@/components/Renewals.vue';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { VSkeletonLoader } from 'vuetify/components/VSkeletonLoader';
import { Account } from '@/types/Account.js';

const loading = ref<boolean>(false);
let groups = ref<ProgramRateGroup[]>([]);
const account = ref<Account>();

const accountId = computed(() => useRoute().params.id as string);

onMounted(async () => {
  if (loading.value) return;
  loading.value = true;

  account.value = await accountService.findById(accountId.value);
  const results = await accountService.getProgramRates(accountId.value);
  groups.value = groupedProgramRates(results);

  loading.value = false;
});
</script>

<template>
  <div class="tw:px-8 tw:py-4">
    <Renewals v-if="!loading" :account-id="accountId" :account-name="account?.displayName ?? account?.accountName" :program-rate-groups="groups" />

    <v-skeleton-loader v-else type="table-row-divider@4" />
  </div>
</template>